/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import ACTIVITY_DATA_ALL from './assets/mock-data/activity-data-all.json';
import { cpsRef } from './redux/middleware/embedding-api';
import { forceProblemType } from './redux/actions/progression';
import store from './redux/store';
import cnf from './its-game-cfg.json';
import {EnvsType, envServers, ITS_CFG, Server, Servers, setLokiParams } from 'its-pages';
const configurations: Record<string, Config> = cnf;

interface Config {
  // server: Server;
  suppressFluentdLogs: boolean;
  moveonCount: number;
  log: boolean;
  testApp: boolean;
  testBody: boolean;
  showConfetti: boolean;
  autoResetButtons: boolean;
  testSkills: boolean;
  [id: string]: number | string | Server | boolean;
}

export type LessonKeys =
  | 'Empathy'
  | 'Enhancing Motivation'
  | 'Reflection'
  | 'Cultural Responsiveness'
  | 'Agenda Setting and Symptom Review'
  | 'Redirection'
  | 'Assigning Homework'
  | 'Reviewing Homework'
  | 'Assessing Suicide Risk'
  | 'Managing Mild to Moderate Suicide Risk'
  | 'Managing Severe Suicide Risk';

const env = import.meta.env.VITE_ENV;
const mode = env === 'production' ? 'Prd' : env === 'staging' ? 'Stg' : 'Local';
// const mode = 'Prd';
class AppCfg extends Servers {

  public static get env(): EnvsType{
    return mode;
  }

  public get suppressFluentdLogs(): boolean {
    //return AppCfg.config.suppressFluentdLogs;
    return true;
  }
  public get moveonCount(): number {
    return AppCfg.config.moveonCount;
  }
  public get log(): boolean {
    return AppCfg.config.log;
  }
  public get testApp(): boolean {
    return ( window.location === window.parent.location );
  }

  public get showConfetti(): boolean {
    return AppCfg.config.showConfetti;
  }

  public get autoResetButtons(): boolean {
    return AppCfg.config.autoResetButtons;
  }

  public get Skills(): boolean {
    return AppCfg.config.testSkills;
  }

  private constructor() {
    super(mode);
  }

  private static instance: AppCfg;
  private static config: Config = {...(configurations[this.env] as Config), ...envServers[this.env]};

  private static modules = ACTIVITY_DATA_ALL;

  public getModule(key: LessonKeys): any {
    return { ...AppCfg.modules[key] };
  }

  public get moduleKeys(): string[] {
    return Object.keys(AppCfg.modules);
  }

  public static getInstance(): AppCfg {
    if (!AppCfg.instance) {
      AppCfg.instance = new AppCfg();
      ITS_CFG.displayMode = AppCfg.instance.testApp;
      setLokiParams({
        url: AppCfg.instance.getServerHref('loki'),
        src: AppCfg.instance.getSrc('loki'),
        bugReportSrc: AppCfg.instance.getBugReportSrc()
      });
    }

    return AppCfg.instance;
  }

  public consoleLog(s: any): void {
    if (AppCfg.config.log) {
      console.log(s);
    }
  }

  public ASSERT_LOG(condition: () => boolean, log: any): void {
    if (this.log && condition()) {
      console.log(log);
    }
  }

  public switchModule(key: LessonKeys): void {
    cpsRef.ecEmulator.stopActivity(['test app message']);
    cpsRef.ecEmulator.startActivity(AppCfg.modules[key]);

    // Delay is needed because activity has async work to finish read in module data
    setTimeout(() => store.dispatch(forceProblemType([0,0])), 200);
  }
}

export const APP_CFG = AppCfg.getInstance();
